<template>
  <div>
    <!-- [ Modal form History Invite ] start -->
    <sweet-modal blocking :title="$t('users_modal_invite_history')" ref="modalHistoryInvite" class="modal" v-on:close="closeModal">

      <el-select v-model="statusId" placeholder="Status" style="margin-bottom: 20px;">
        <el-option v-for="item in statusList"
          :key="item.id"
          :label="label(item.id)"
          :value="item.id"
          @click.native="listInvite(item.id)">
        </el-option>
      </el-select>

      <el-alert
        :title="tooltip"
        type="info"
        show-icon
        :closable="false"
        style="margin-bottom: 20px;">
      </el-alert>
      
      <el-table :data="list" element-loading-text="Loading" border>
        <el-table-column :label="$t('users_modal_invite_history_email')">
          <template slot-scope="scope">
            {{ scope.row.email }}
          </template>
        </el-table-column>
        <el-table-column :label="$t('users_modal_invite_history_status')">
          <template slot-scope="scope">
            {{ scope.row.statusName }}
          </template>
        </el-table-column>
        <el-table-column align="center" :label="$t('users_modal_invite_history_actions')" width="100">
          <template slot-scope="scope">
            <el-button v-if="scope.row.statusName == 'Send' || scope.row.statusName == 'Resend'" @click="resendSubmit(scope.row.email)" type="warning" size="small" :title="$t('users_modal_invite_history_resend')">
              <!-- <el-tooltip effect="dark" content="Top Left prompts info" placement="top-start">
                <el-button><i class="fas fa-reply"></i></el-button>
              </el-tooltip> -->
              <i class="fas fa-reply"></i>
            </el-button>
          </template>
        </el-table-column>
      </el-table>

    </sweet-modal>
    <!-- [ Modal form History Invite ] end -->
  </div>
</template>

<script>
import { SweetModal } from '@totalflow4/tfsweet-modal-vue'
import axios from 'axios'
export default {
  components: {
    SweetModal,
  },
  props: ['modalHistoryInvite', 'directories'],
  watch: {
    directories: function (val) {
      this.list = this.directories.list;
      this.statusList = this.directories.statusList;
    },
    statusId: function (val) {
      if (val === 'null') {
        this.tooltip = this.$i18n.t('users_modal_invite_history_all_desc')
      } else if (val == 1) {
        this.tooltip = this.$i18n.t('users_modal_invite_history_sent_desc')
      } else if (val == 2) {
        this.tooltip = this.$i18n.t('users_modal_invite_history_resent_desc')
      } else if (val == 3) {
        this.tooltip = this.$i18n.t('users_modal_invite_history_accepted_desc')
      } else if (val == 4) {
        this.tooltip = this.$i18n.t('users_modal_invite_history_declined_desc')
      }
    }
  },
  data() {
    return {
      list: [],
      statusList: [],
      statusId: 'null',
      tooltip: this.$i18n.t('users_modal_invite_history_all_desc')
    }
  },
  methods: {
    label(id) {
      if (id === 'null') {
        return this.$i18n.t('users_modal_invite_history_all')
      } else if (id == 1) {
        return this.$i18n.t('users_modal_invite_history_sent')
      } else if (id == 2) {
        return this.$i18n.t('users_modal_invite_history_resent')
      } else if (id == 3) {
        return this.$i18n.t('users_modal_invite_history_accepted')
      } else if (id == 4) {
        return this.$i18n.t('users_modal_invite_history_declined')
      }
    },
    resendSubmit(email) {
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
      axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
      axios
        .post(`/api/v1/companyUsers/reinviteUser?companyId=${this.$route.query.companyId}&email=${email}`)
        .then(response => {
          this.listInvite(null)
          this.notification("Success", "Invitation sent", "success");
        })
        .catch(error => {
          this.notification("Notification", error.response.data.message, "info");
        });
    },
    listInvite(status) {
      let loader = this.$loading.show();
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
      axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
      axios
        .post(`/api/v1/invite/list?companyId=${this.$route.query.companyId}&status=${status}`)
        .then(response => {
          this.list = response.data.list
          loader.hide()
        })
        .catch(error => {
          this.notification("Notification", error.response.data.message, "info");
        });
    },
    closeModal() {
      
    },
    notification(title, message, type) {
      this.$notify({
        title: title,
        message: message,
        type: type
      });
    },
  },
}
</script>
